// extracted by mini-css-extract-plugin
export default {"blogsPage":"styles_blogsPage__9toSf","headline":"styles_headline__Ig2SQ","mainContent":"styles_mainContent__qnc6L","blogsWrapper":"styles_blogsWrapper__rfG9-"};